import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import { isEmpty } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { DateRangeCard } from "../Common/DateRangeCard"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { getUserPerformance } from "helpers/repository"
import { call } from "redux-saga/effects"
import { currency } from "../../../constants/constants"

const Performance = props => {
  const dispatch = useDispatch()
  const [summary, setSummary] = useState(null)

  const [from, setFrom] = useState("")
  const [to, setTo] = useState("")
  const [dailyPerformance, setDailyPerformance] = useState([])
  const selectRow = {
    mode: "checkbox",
  }

  const call = () => {
    getUserPerformance(props.userId, successCallback, error, from, to)
  }

  const successCallback = res => {
    setSummary(res.data.summary)
    setDailyPerformance(res.data.daily_performance)
  }
  const error = err => {
    console.log("error")
  }
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [orderList, setOrderList] = useState([])
  const [isEdit, setIsEdit] = useState(false)

  //pagination customization
  const pageOptions = {
    sizePerPage: 20,
    totalSize: dailyPerformance.length,
    custom: true,
  }

  useEffect(() => {
    call()
  }, [props.userId])
  const { SearchBar } = Search

  // const toggleModal = () => {
  //   setModal1(!modal1)
  // }
  const toggleViewModal = () => setModal1(!modal1)

  const EcommerceOrderColumns = [
    {
      dataField: "date",
      text: "Date",
      sort: true,
    },
    {
      dataField: "bet_count",
      text: "Bet Count",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.bet_count).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "total_stake",
      text: "Total Stake",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.total_stake.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "payouts",
      text: "Payouts",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.payouts.toFixed(2)).toLocaleString("en-GB")}</>
      ),
    },
    {
      dataField: "profit_loss",
      text: "Profit Loss",
      sort: true,
      formatter: (cell, row) => (
        <>{Number(row.profit_loss.toFixed(2)).toLocaleString("en-GB")}%</>
      ),
    },
    {
      dataField: "deposits",
      text: "Deposits",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(parseFloat(row.deposits ?? 0)?.toFixed(2)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },
    {
      dataField: "withdrawals",
      text: "Withdrawls",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(parseFloat(row.withdrawals ?? 0)?.toFixed(2)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },
    {
      dataField: "bonus",
      text: "Bonuses",
      sort: true,
      formatter: (cell, row) => (
        <>
          {Number(parseFloat(row.bonus ?? 0)?.toFixed(2)).toLocaleString(
            "en-GB"
          )}
        </>
      ),
    },
  ]

  const toggle = () => {
    setModal(!modal)
  }

  const toLowerCase1 = str => {
    return str.toLowerCase()
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  return (
    <React.Fragment>
      <DateRangeCard
        call={() => {
          call()
        }}
        setFrom={v => setFrom(v)}
        setTo={v => setTo(v)}
      />
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Performance Summary</CardTitle>
          <Row>
            <Col lg={12}>
              <Row>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Number of Bets</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {Number(summary?.no_of_bets ?? 0).toLocaleString(
                          "en-GB"
                        )}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Total Stakes</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {Number(summary?.total_stakes ?? 0).toLocaleString(
                          "en-GB"
                        )}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Total Payouts</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {" "}
                        {Number(
                          summary?.total_payouts.toFixed(2) ?? 0
                        ).toLocaleString("en-GB")}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">GGR Ratio</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {summary?.ggr_ratio.toFixed(2) ?? 0}%
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col lg={12}>
              <Row>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Average Stake</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {Number(
                          parseFloat(summary?.average_stakes)?.toFixed(2)
                        ).toLocaleString("en-GB")}{" "}
                        {currency}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Deposits</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {Number(
                          parseFloat(summary?.deposits ?? 0)?.toFixed(2)
                        ).toLocaleString("en-GB")}{" "}
                        {currency}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Withdrawls</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {Number(
                          parseFloat(summary?.withdrawls ?? 0)?.toFixed(2)
                        ).toLocaleString("en-GB")}{" "}
                        {currency}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Label className="col-form-label">Bonus</Label>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {Number(
                          parseFloat(summary?.bonus ?? 0)?.toFixed(2)
                        ).toLocaleString("en-GB")}{" "}
                        {currency}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Daily Performance</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={EcommerceOrderColumns}
            data={dailyPerformance}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={dailyPerformance}
                columns={EcommerceOrderColumns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            // selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default withRouter(Performance)
